import { createSlice } from '@reduxjs/toolkit';

import thunks from './addressSlice.thunks';
import type {
  AddressDataType,
} from '../../api/api.types';

type InitialStateType = {
  addresses: AddressDataType[];
  activeTable: string;
  loading: boolean;
  activeTableRowsCount: number;
  reserveTableRowsCount: number;
};

const getInitialStore = (): InitialStateType => ({
  addresses: [],
  loading: false,
  activeTable: '1',
  activeTableRowsCount: 0,
  reserveTableRowsCount: 0,
});

const addressSlice = createSlice({
  name: 'address',
  initialState: getInitialStore,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(thunks.getAddressesByPostcode.fulfilled, (store, { payload }) => {
      store.addresses = payload;
    });
    builder.addCase(thunks.getAddressesByPostcode.pending, (store) => {
      store.addresses = [];
    });

    builder.addCase(thunks.getAddressesByText.fulfilled, (store, { payload }) => {
      store.addresses = payload;
    });
    builder.addCase(thunks.getAddressesByText.pending, (store) => {
      store.addresses = [];
    });
    builder.addCase(thunks.getAddressesByTextOrPostcode.fulfilled, (store, { payload }) => {
      store.addresses = payload;
    });
    builder.addCase(thunks.getAddressesByTextOrPostcode.pending, (store) => {
      store.addresses = [];
    });
    builder.addCase(thunks.toggleTable.pending, (store) => {
      store.loading = true;
    });
    builder.addCase(thunks.getActiveTableInfo.pending, (store) => {
      store.loading = true;
    });
    builder.addCase(thunks.clearReverseTable.pending, (store) => {
      store.loading = true;
    });
    builder.addCase(thunks.toggleTable.fulfilled, (store, { payload }) => {
      store.activeTable = payload.activeTable;
      store.activeTableRowsCount = payload.activeTableRowsCount;
      store.reserveTableRowsCount = payload.reserveTableRowsCount;
      store.loading = false;
    });
    builder.addCase(thunks.getActiveTableInfo.fulfilled, (store, { payload }) => {
      store.activeTable = payload.activeTable;
      store.activeTableRowsCount = payload.activeTableRowsCount;
      store.reserveTableRowsCount = payload.reserveTableRowsCount;
      store.loading = false;
    });
    builder.addCase(thunks.clearReverseTable.fulfilled, (store) => {
      store.reserveTableRowsCount = 0;
      store.loading = false;
    });
    builder.addCase(thunks.toggleTable.rejected, (store) => {
      store.loading = false;
    });
    builder.addCase(thunks.getActiveTableInfo.rejected, (store) => {
      store.loading = false;
    });
    builder.addCase(thunks.clearReverseTable.rejected, (store) => {
      store.loading = false;
    });
  },
});

export const addressSliceActions = addressSlice.actions;

export default addressSlice.reducer;
